export function trimAndLimitCharactersNumber({
  text,
  limit,
}: {
  text?: string;
  limit: number;
}): string {
  if (!text) {
    return '';
  }

  const textTrimmed = text.toString().trim();

  if (limit && textTrimmed.length > limit) {
    return `${textTrimmed.substring(0, limit - 3)}...`;
  }

  return textTrimmed;
}

export function camelCaseToKebabCase(camelCaseText: string) {
  return camelCaseText?.replace(/[A-Z]/g, (str) => `-${str.toLowerCase()}`);
}

const UID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function isUidString(text: string) {
  return UID_REGEX.test(text);
}

export function kebabCaseToCamelCase(kebabCaseText: string) {
  return kebabCaseText?.replace(/-./g, (str) => str[1].toUpperCase());
}

export function toUpperFirst(
  text: string,
  { lowerCaseRest }: { lowerCaseRest?: boolean } = { lowerCaseRest: true },
) {
  return text.replace(/^(.)(.*)/, (_, firstLetter, remainingText) => {
    return `${firstLetter.toUpperCase()}${
      lowerCaseRest ? remainingText.toLowerCase() : remainingText
    }`;
  });
}

export function toStartCase(text: string) {
  return text
    .split(/[\s_-]/)
    .map((str) => toUpperFirst(str))
    .join(' ');
}

export function extractTextFromHtmlContent(htmlContent: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  return doc.body.textContent || '';
}
